import React from 'react'
import { Link } from 'react-router-dom'
import {
  IonGrid,
  IonRow,
  IonChip,
  IonLabel
} from '@ionic/react'
import { NewsRadioCard } from '../../../components/common/NewsRadioCard'
import './styles.scss'

const ReadFooter = (props) => {
  const { content, related } = props

  return (
    <section className='read-footer'>
      <section className='post-tags'>
        {content?.header?.tags && content.header.tags.map((tag) => (
          <Link
            to={`/news/1/${tag.alias}`}
            key={tag.id}
            className='chip-link'
          >
            <IonChip>
              <IonLabel>{tag.name}</IonLabel>
            </IonChip>
          </Link>
        ))}
      </section>
      <section className='related-content'>
        <h1 className='related-title'>Tal vez te pueda interesar:</h1>
        <IonGrid>
          <IonRow>
            {related?.related?.following?.result === true && <NewsRadioCard content={related.related.following.data} />}
            {related?.related?.previous?.result === true && <NewsRadioCard content={related.related.previous.data} />}
          </IonRow>
        </IonGrid>
      </section>
    </section>
  )
}

export default ReadFooter
